import styled from 'styled-components';

export const Text = styled.p`
  font-size: ${(props) => props.size || '16px'};
  font-weight: ${(props) => props.weight || 'normal'};
  line-height: 150%;
  color: ${(props) => props.color || props.theme.colors.primaryText};
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  text-align: ${(props) => props.align || 'left'};
  background-color: ${(props) => props.bg_color || 'none'};
  white-space: normal; /* 자동 줄바꿈 허용 */
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const Title = styled(Text).attrs({ as: 'h1' })`
  font-size: ${(props) => props.size || props.theme.fontSizes.large};
  font-weight: ${(props) => props.weight || 'bold'};
  color: ${(props) => props.color || props.theme.colors.primaryText};
`;

export const Subtitle = styled(Text).attrs({ as: 'h2' })`
  font-size: ${(props) => props.size || props.theme.fontSizes.medium};
  color: ${(props) => props.color || props.theme.colors.secondaryText};
  font-weight: ${(props) => props.weight || 'bold'};
`;

export const BodyText = styled(Text)`
  font-size: ${(props) => props.size || props.theme.fontSizes.small};
  font-weight: ${(props) => props.weight || 'normal'};
  color: ${(props) => props.color || props.theme.colors.menuText};
`;
